(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["litelier-help"] && !Shopify.designMode) return;
  try {
    
  /* The theme scrolls inside .page-wrapper (html/body overflow: hidden, smooth
     scrolling), so jump to topics ourselves with an instant scroll: on load
     (links from emails and START-HERE, e.g. /pages/help#zip) and on
     jump-list / back-to-top clicks. */
  (() => {
    const root = document.querySelector('.lhelp');
    if (!root) return;
    const scrollerOf = (el) => {
      for (let p = el.parentElement; p; p = p.parentElement) {
        const overflow = getComputedStyle(p).overflowY;
        if ((overflow === 'auto' || overflow === 'scroll') && p.scrollHeight > p.clientHeight) return p;
      }
      return document.scrollingElement;
    };
    const goTo = (id) => {
      if (!id) return false;
      const target = document.getElementById(decodeURIComponent(id));
      if (!target || !root.contains(target)) return false;
      const scroller = scrollerOf(target);
      const offset = scroller === document.scrollingElement ? 0 : scroller.getBoundingClientRect().top;
      // Land just below the sticky header (its real height differs per breakpoint).
      const header = document.querySelector('header');
      const sticky = header && ['sticky', 'fixed'].includes(getComputedStyle(header).position);
      const margin = (sticky ? header.getBoundingClientRect().height : 0) + 12;
      // 'instant' overrides the theme's smooth scrolling on .page-wrapper.
      const top = target === root ? 0 : scroller.scrollTop + target.getBoundingClientRect().top - offset - margin;
      scroller.scrollTo({ top, behavior: 'instant' });
      const heading = target.querySelector('.lhelp__heading') || target;
      heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: true });
      return true;
    };
    const fromHash = () => goTo(location.hash.slice(1));
    root.addEventListener('click', (event) => {
      const link = event.target instanceof Element ? event.target.closest('a[href^="#"]') : null;
      if (!link) return;
      const id = link.getAttribute('href').slice(1);
      if (!goTo(id)) return;
      event.preventDefault();
      history.pushState(null, '', '#' + id);
    });
    window.addEventListener('hashchange', fromHash);
    if (location.hash) {
      fromHash();
      window.addEventListener('load', () => setTimeout(fromHash, 150), { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
